import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { InputSelector } from "../../components/Forms/InputSelector";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiAgent from "../../api/apiAgent";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle } from "../../utils";

const UpdateSingleItem = (): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams();
  const itemName = params.item?.toString() || "";

  const [itemData, setItemData] = useState<any>();
  const [schema, setSchema] = useState<any[]>([]);
  const [rawSchema, setRawSchema] = useState<string>("");
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);
  const [isLoadingSchema, setIsLoadingSchema] = useState<boolean>(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await apiAgent.SingleItem.get(itemName);

      if (response.status === 200) {
        const getData = JSON.parse(response.data.data);
        const getSchema = JSON.parse(response.data.schema);
        const parsedSchema = Object.keys(getSchema).map((i) => {
          return {
            name: i,
            type: getSchema[i],
          };
        });
        setItemData(getData);
        setRawSchema(response.data.schema);
        setSchema(parsedSchema);
      } else {
        tMsg.error(`${itemName} does not exist`);
        navigate("/error");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoadingData(false);
      setIsLoadingSchema(false);
    }
  };

  const updateItemData = (keyname: string, value: any) => {
    if (_.has(itemData, keyname))
      setItemData({
        ...itemData,
        [keyname]: value,
      });
  };

  const saveItem = async () => {
    try {
      // update item api call
      const response = await apiAgent.SingleItem.update(
        itemName,
        itemData,
        rawSchema
      );

      if (response.status === 200) {
        tMsg.success(`${itemName} successfully updated`);
        navigate(`/si/${itemName}`);
      } else throw response.statusText;
    } catch (err) {
      tMsg.error(`Error changing ${itemName}`);
      console.log(err);
    }
  };

  const crumbs = [
    {
      label: checkTitle(itemName),
      link: `/m/${itemName}`,
    },
  ];

  return (
    <PageContainer
      isLoading={isLoadingData || isLoadingSchema}
      className="relative"
    >
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Edit ${itemName}`}>
          <BackButton />
        </TitleBar>
        <form>
          <div className="flex flex-col gap-4">
            {schema.map((item, index) => (
              <InputSelector
                key={index}
                onChange={(e) => {
                  updateItemData(
                    item.name,
                    item.type === "number"
                      ? e.target.valueAsNumber
                      : e.target.value
                  );
                }}
                value={itemData ? itemData[item.name] : undefined}
                {...item}
              />
            ))}
          </div>
        </form>
      </PageContent>
      <PageFooterBar>
        <SaveButton onClick={() => saveItem()} />
      </PageFooterBar>
    </PageContainer>
  );
};

export default UpdateSingleItem;
